
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.791 1.778c.345-.34.81-.528 1.292-.528h10.834c.482 0 .947.189 1.292.528.345.34.541.803.541 1.289V18a.75.75 0 01-1.276.534l-1.64-1.615-1.641 1.615a.75.75 0 01-1.053 0L9.5 16.92l-1.64 1.615a.75.75 0 01-1.053 0l-1.64-1.615-1.64 1.615A.75.75 0 012.25 18V3.067c0-.486.196-.95.541-1.289zm1.292.972a.342.342 0 00-.24.097.308.308 0 00-.093.22v13.142l.89-.877a.75.75 0 011.053 0l1.64 1.616 1.64-1.616a.75.75 0 011.053 0l1.64 1.616 1.641-1.616a.75.75 0 011.053 0l.89.877V3.067c0-.08-.032-.16-.094-.22a.342.342 0 00-.24-.097H4.084zm.334 2.983a.75.75 0 01.75-.75H9.5a.75.75 0 110 1.5H5.167a.75.75 0 01-.75-.75zm.75 2.45a.75.75 0 000 1.5H9.5a.75.75 0 000-1.5H5.167zm-.75 3.95a.75.75 0 01.75-.75H9.5a.75.75 0 110 1.5H5.167a.75.75 0 01-.75-.75zm8.062-7.15a.75.75 0 000 1.5h.813a.75.75 0 000-1.5h-.813zm-.75 3.95a.75.75 0 01.75-.75h.813a.75.75 0 010 1.5h-.813a.75.75 0 01-.75-.75zm.75 2.45a.75.75 0 100 1.5h.813a.75.75 0 000-1.5h-.813z"}})])
          )
        }
      }
    